var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNftTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_53245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4576 11.8172C62.4576 -8.68491 36.6421 5.56084 23.6238 4.98472C18.7263 4.76797 7.34751 -3.78916 2.74051 2.01559C-3.18824 9.48572 14.798 20.6592 14.6128 30.1943C14.448 38.6763 9.38376 46.9145 15.0664 55.0426C25.6303 70.1527 46.3095 65.09 46.3095 47.7582C46.3095 25.6955 62.4576 23.1486 62.4576 11.8172Z",
    fill: "url(#paint0_linear_1543_53245)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.3708 52.9081L48.4578 43.1837C48.0713 42.762 47.6353 42.3936 47.1623 42.0845L45.9079 39.5515C45.187 38.096 43.928 36.9782 42.3973 36.4351L39.1058 35.2671C37.7019 34.769 36.3644 34.1006 35.1231 33.277L32.2316 31.3583H35.6241C37.1606 31.3583 38.5923 30.5317 39.3604 29.2012L40.633 26.9971L44.6623 29.5592C44.6356 29.6828 44.6208 29.8107 44.6208 29.9423C44.6208 30.9412 45.4305 31.7511 46.4295 31.7511C47.4285 31.7511 48.2383 30.9412 48.2383 29.9423C48.2383 28.9435 47.4284 28.1336 46.4295 28.1336C46.0173 28.1336 45.6385 28.2731 45.3343 28.5053L41.2585 25.9137L42.9846 22.924C43.261 22.4451 43.4364 21.9243 43.5138 21.392H48.2465V22.8871C48.2465 23.0241 48.3261 23.1482 48.4491 23.2056L51.8116 24.7785C51.8585 24.8007 51.9089 24.8125 51.9604 24.8125H51.9663L51.9664 24.8118C52.0159 24.811 52.0641 24.8 52.1091 24.7786L55.4716 23.2057C55.5946 23.1483 55.6743 23.0242 55.6743 22.8872V18.6463C55.6743 18.5751 55.6516 18.5082 55.6133 18.4513L55.6145 18.4507C55.6129 18.4482 55.6104 18.4466 55.6088 18.4442C55.607 18.4418 55.6058 18.4391 55.604 18.4367L55.6024 18.4371C55.5683 18.3913 55.5245 18.3532 55.4716 18.3278L52.1091 16.755C52.0154 16.7105 51.9054 16.7105 51.8116 16.755L48.4491 18.3278C48.3935 18.3546 48.3471 18.3947 48.3124 18.4438L48.3121 18.4437C48.3119 18.4441 48.3116 18.4446 48.3114 18.4451C48.3099 18.4472 48.3078 18.4487 48.3063 18.4508L48.3075 18.4515C48.2686 18.5085 48.2465 18.5757 48.2465 18.6465V20.1422H43.5136C43.4361 19.6098 43.2609 19.089 42.9844 18.6101L41.2584 15.6206L45.3341 13.029C45.6384 13.2612 46.0171 13.4006 46.4293 13.4006C47.4281 13.4006 48.238 12.5908 48.238 11.5918C48.238 10.593 47.4281 9.78308 46.4293 9.78308C45.4304 9.78308 44.6205 10.5928 44.6205 11.5918C44.6205 11.7235 44.6354 11.8513 44.662 11.975L40.6328 14.5371L39.3603 12.333C38.592 11.0023 37.1604 10.1758 35.6239 10.1758H28.3756C26.8391 10.1758 25.4075 11.0025 24.6395 12.333L23.3669 14.5372L19.3376 11.9751C19.3644 11.8515 19.3791 11.7235 19.3791 11.592C19.3791 10.5931 18.5694 9.78321 17.5704 9.78321C16.5714 9.78321 15.7616 10.593 15.7616 11.592C15.7616 12.591 16.5714 13.4007 17.5704 13.4007C17.9826 13.4007 18.3614 13.2612 18.6655 13.0291L22.7413 15.6208L21.0151 18.6105C20.7386 19.0893 20.5634 19.6101 20.4859 20.1425H15.7531V18.6467C15.7531 18.5755 15.7304 18.5086 15.6921 18.4517L15.6934 18.4511C15.6918 18.4486 15.6893 18.447 15.6875 18.4446C15.6858 18.4422 15.6845 18.4395 15.6828 18.4371L15.6811 18.4375C15.647 18.3917 15.6033 18.3536 15.5504 18.3282L12.1879 16.7553C12.0941 16.7108 11.9841 16.7108 11.8904 16.7553L8.52789 18.3282C8.47214 18.355 8.42589 18.3951 8.39114 18.4442L8.39089 18.4441C8.39064 18.4445 8.39039 18.445 8.39001 18.4455C8.38851 18.4476 8.38639 18.4491 8.38501 18.4512L8.38626 18.4518C8.34726 18.5088 8.32526 18.5761 8.32526 18.6468V22.8877C8.32526 23.0247 8.40489 23.1488 8.52789 23.2062L11.8904 24.7791C11.9373 24.8013 11.9876 24.8131 12.0391 24.8131H12.045L12.0451 24.8125C12.0945 24.8116 12.1429 24.8006 12.1879 24.7792L15.5504 23.2063C15.6734 23.149 15.753 23.0248 15.753 22.8878V21.3927H20.4858C20.5633 21.9251 20.7385 22.446 21.015 22.9248L22.741 25.9145L18.6653 28.5061C18.361 28.2738 17.9823 28.1343 17.57 28.1343C16.571 28.1343 15.7613 28.9441 15.7613 29.9431C15.7613 30.9421 16.571 31.7518 17.57 31.7518C18.5689 31.7518 19.3788 30.942 19.3788 29.9431C19.3788 29.8116 19.3639 29.6836 19.3373 29.56L23.3665 26.9978L24.639 29.202C24.9583 29.7551 25.3934 30.2193 25.9019 30.5751C25.5989 31.8102 26.0145 33.1707 27.0924 34.0108L33.4646 38.9775L25.5621 38.206C25.3493 36.6726 24.0246 35.4947 22.428 35.5146C21.6953 35.5237 21.1128 36.1366 21.1128 36.8693V37.7717L19.9144 37.6547L18.2825 36.6362C18.262 34.928 16.8716 33.5493 15.1585 33.5493C14.9915 33.5493 14.8324 33.5825 14.6863 33.641C14.6793 31.921 13.2831 30.5288 11.5616 30.5288C10.8673 30.5288 10.3039 31.086 10.2921 31.7776C8.88551 31.3541 7.31526 31.9766 6.61764 33.356C6.28676 34.0101 6.50926 34.8086 7.13051 35.1975L10.2908 37.1757L10.2906 39.7061C10.2906 40.5988 10.8471 41.397 11.6849 41.7053L13.8875 42.5165V42.7266C13.8875 43.6193 14.444 44.4175 15.2818 44.726L23.9171 47.0503L24.547 47.7992C24.8103 48.1122 25.1911 48.3023 25.5995 48.3247L34.9494 48.8356L44.7319 62.0662C44.9181 62.3181 45.2614 62.3935 45.5356 62.2422C47.1543 61.3502 52.5656 58.223 57.3323 53.7917C57.5855 53.556 57.6038 53.1623 57.3708 52.9081Z",
    fill: "#0274B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5703 26.9422L46.4291 8.59143",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4291 26.9422L17.5703 8.59143",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3968 33.4351L39.1053 32.2671C37.7014 31.769 36.3639 31.1006 35.1226 30.277L28.3918 25.8108C27.8736 25.467 27.1816 25.5563 26.7678 26.0204L26.6528 26.1494C25.3663 27.592 25.568 29.8219 27.0926 31.0101L33.4649 35.9768L19.9146 34.654L11.0458 29.1186C9.49314 28.1496 7.44364 28.7219 6.61764 30.3551C6.28676 31.0093 6.50926 31.8078 7.13051 32.1966L16.5744 38.1081L26.6839 42.2989L43.1995 46.2855L47.3975 39.5606L45.9074 36.5516C45.1866 35.096 43.9275 33.9783 42.3968 33.4351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3968 33.4351L39.1053 32.2671C37.7014 31.769 36.3639 31.1006 35.1226 30.277L28.3918 25.8108C27.8736 25.467 27.1816 25.5563 26.7678 26.0204L26.6528 26.1494C25.3663 27.592 25.568 29.8219 27.0926 31.0101L33.4649 35.9768L19.9146 34.654L11.0458 29.1186C9.49314 28.1496 7.44364 28.7219 6.61764 30.3551C6.28676 31.0093 6.50926 31.8078 7.13051 32.1966L16.5744 38.1081L26.6839 42.2989L43.1995 46.2855L47.3975 39.5606L45.9074 36.5516C45.1866 35.096 43.9275 33.9783 42.3968 33.4351Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2686 36.5056L14.9096 35.9802L14.6869 30.653C14.6869 28.9271 13.2878 27.528 11.5619 27.528C10.8601 27.528 10.2913 28.0968 10.2913 28.7986L10.291 36.7052C10.291 37.598 10.8475 38.3961 11.6853 38.7046L16.2686 40.3923V36.5056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2686 36.5056L14.9096 35.9802L14.6869 30.653C14.6869 28.9271 13.2878 27.528 11.5619 27.528C10.8601 27.528 10.2913 28.0968 10.2913 28.7986L10.291 36.7052C10.291 37.598 10.8475 38.3961 11.6853 38.7046L16.2686 40.3923V36.5056Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5208 45.2887L15.281 41.725C14.4432 41.4165 13.8866 40.6183 13.8867 39.7256L13.887 31.819C13.887 31.1172 14.4558 30.5485 15.1576 30.5485C16.8835 30.5485 18.2826 31.9476 18.2826 33.6735V37.6538L25.5918 39.3995L28.5208 45.2887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5208 45.2887L15.281 41.725C14.4432 41.4165 13.8866 40.6183 13.8867 39.7256L13.887 31.819C13.887 31.1172 14.4558 30.5485 15.1576 30.5485C16.8835 30.5485 18.2826 31.9476 18.2826 33.6735V37.6538L25.5918 39.3995L28.5208 45.2887Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4578 40.1838C47.4579 39.0929 46.1303 38.3542 44.6737 38.0933C43.0684 37.8058 40.6625 37.5979 37.3665 37.872C33.4042 38.2017 29.2765 41.4834 29.2765 41.4834L25.5933 39.3995V35.6387C25.5933 33.8995 24.1727 32.4923 22.4285 32.5139C21.6958 32.523 21.1133 33.1359 21.1133 33.8687V40.175C21.1133 40.5238 21.2364 40.8613 21.4608 41.1282L24.5475 44.7984C24.8108 45.1114 25.1917 45.3015 25.6 45.3239L34.9499 45.8348L44.7324 59.0654C44.9187 59.3173 45.2619 59.3927 45.5363 59.2414C47.1549 58.3494 52.5663 55.2222 57.3329 50.7909C57.5855 50.556 57.6038 50.1624 57.3708 49.9082L48.4578 40.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3665 37.872C33.4042 38.2015 29.2765 41.4834 29.2765 41.4834L25.5933 39.3995V35.6387C25.5933 33.8995 24.1727 32.4922 22.4285 32.5139C21.6958 32.523 21.1133 33.1359 21.1133 33.8687V40.175C21.1133 40.5238 21.2364 40.8613 21.4608 41.1282L24.5475 44.7984C24.8108 45.1114 25.1917 45.3015 25.6 45.3239L34.9499 45.8348L44.7324 59.0654C44.9187 59.3173 45.2619 59.3927 45.5362 59.2414C47.1548 58.3494 52.5662 55.2222 57.3328 50.7909C57.5854 50.556 57.6037 50.1624 57.3707 49.9082L54.367 46.631",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8572 43.8924L48.458 40.1838C47.4581 39.0929 46.1305 38.3541 44.6738 38.0933",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9492 45.8346L38.892 46.012C39.4602 46.0376 40.0305 45.9715 40.5727 45.7998C41.6838 45.4478 43.3777 44.5821 44.5105 42.4679",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6426 17.7668H48.2446",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.752 17.7668H20.354",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6853 16.8185L51.9639 21.8124H51.958C51.9065 21.8124 51.8561 21.8006 51.8093 21.7784L48.4468 20.2055C48.3238 20.1481 48.2441 20.024 48.2441 19.8869V15.646C48.2441 15.5722 48.2675 15.502 48.3098 15.4434L52.6853 16.8185Z",
    fill: "#0274B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6709 15.646V19.8869C55.6709 20.0239 55.5913 20.148 55.4683 20.2055L52.1058 21.7784C52.0589 21.8006 52.0085 21.8124 51.957 21.8124V16.1884L55.6005 15.4365C55.6452 15.4961 55.6709 15.5688 55.6709 15.646Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6129 15.4504L51.9588 17.1592L48.3047 15.4504C48.3398 15.3977 48.3891 15.3556 48.4476 15.3274L51.8101 13.7546C51.9038 13.7101 52.0138 13.7101 52.1076 13.7546L55.4701 15.3274C55.5286 15.3556 55.5778 15.3978 55.6129 15.4504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6109 15.4511L55.6121 15.4504C55.6105 15.4479 55.608 15.4463 55.6064 15.4439C55.6046 15.4416 55.6034 15.4388 55.6016 15.4364L55.6 15.4368C55.5659 15.3911 55.5221 15.3529 55.4693 15.3276L52.1068 13.7547C52.013 13.7102 51.903 13.7102 51.8093 13.7547L48.4468 15.3276C48.3911 15.3543 48.3448 15.3944 48.31 15.4436L48.3098 15.4434C48.3095 15.4438 48.3093 15.4443 48.3089 15.4448C48.3074 15.4469 48.3053 15.4484 48.3039 15.4506L48.3051 15.4512C48.2663 15.5082 48.2441 15.5754 48.2441 15.6462V19.8871C48.2441 20.0241 48.3238 20.1482 48.4468 20.2057L51.8093 21.7786C51.8561 21.8008 51.9065 21.8126 51.958 21.8126H51.9639L51.964 21.8119C52.0134 21.8111 52.0618 21.8001 52.1068 21.7787L55.4693 20.2058C55.5923 20.1484 55.6719 20.0243 55.6719 19.8872V15.6463C55.6719 15.5748 55.6491 15.5079 55.6109 15.4511Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7653 16.8185L12.044 21.8124H12.0381C11.9866 21.8124 11.9362 21.8006 11.8893 21.7784L8.52684 20.2055C8.40384 20.1481 8.32422 20.024 8.32422 19.8869V15.646C8.32422 15.5722 8.34759 15.502 8.38984 15.4434L12.7653 16.8185Z",
    fill: "#0274B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.751 15.646V19.8869C15.751 20.0239 15.6714 20.148 15.5484 20.2055L12.1859 21.7784C12.139 21.8006 12.0886 21.8124 12.0371 21.8124V16.1884L15.6806 15.4365C15.7252 15.4961 15.751 15.5688 15.751 15.646Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.693 15.4504L12.0389 17.1592L8.38477 15.4504C8.41989 15.3977 8.46914 15.3556 8.52764 15.3274L11.8901 13.7546C11.9839 13.7101 12.0939 13.7101 12.1876 13.7546L15.5501 15.3274C15.6088 15.3556 15.6579 15.3978 15.693 15.4504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.691 15.4511L15.6922 15.4504C15.6906 15.4479 15.6881 15.4463 15.6865 15.4439C15.6847 15.4416 15.6835 15.4388 15.6817 15.4364L15.6801 15.4368C15.646 15.3911 15.6022 15.3529 15.5493 15.3276L12.1868 13.7547C12.0931 13.7102 11.9831 13.7102 11.8893 13.7547L8.52684 15.3276C8.47122 15.3543 8.42484 15.3944 8.39009 15.4436L8.38984 15.4434C8.38959 15.4438 8.38934 15.4443 8.38897 15.4448C8.38747 15.4469 8.38534 15.4484 8.38397 15.4506L8.38522 15.4512C8.34622 15.5082 8.32422 15.5754 8.32422 15.6462V19.8871C8.32422 20.0241 8.40384 20.1482 8.52684 20.2057L11.8893 21.7786C11.9362 21.8008 11.9866 21.8126 12.0381 21.8126H12.044L12.0441 21.8119C12.0935 21.8111 12.1418 21.8001 12.1868 21.7787L15.5493 20.2058C15.6723 20.1484 15.752 20.0243 15.752 19.8872V15.6463C15.752 15.5748 15.7293 15.5079 15.691 15.4511Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.376 28.3582C26.8395 28.3582 25.4079 27.5315 24.6398 26.201L21.0156 19.9239C20.2474 18.5933 20.2474 16.9403 21.0156 15.6098L24.6399 9.33242C25.408 8.00192 26.8396 7.17529 28.376 7.17529H35.6243C37.1608 7.17529 38.5924 8.00192 39.3606 9.33242L42.9846 15.6095C43.7529 16.9402 43.7529 18.5932 42.9848 19.9237L39.3605 26.201C38.5924 27.5315 37.1608 28.3582 35.6243 28.3582H28.376Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0692 7.17529H28.3759C26.8394 7.17529 25.4078 8.00192 24.6398 9.33242L21.0155 15.6098C20.2474 16.9403 20.2474 18.5933 21.0155 19.9239L24.6397 26.201C25.4078 27.5317 26.8394 28.3582 28.3759 28.3582H35.6242C37.1607 28.3582 38.5923 27.5315 39.3604 26.201L42.9847 19.9237C43.7528 18.5932 43.7528 16.9402 42.9845 15.6095L39.3605 9.33242C38.5923 8.00179 37.1607 7.17529 35.6242 7.17529H33.7805",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6242 10.3004H28.3758C27.9509 10.3004 27.5584 10.527 27.3459 10.895L23.7218 17.1723C23.5094 17.5402 23.5094 17.9935 23.7218 18.3614L27.3459 24.6387C27.5583 25.0065 27.9509 25.2333 28.3758 25.2333H35.6242C36.049 25.2333 36.4415 25.0067 36.654 24.6387L40.2782 18.3614C40.4905 17.9935 40.4905 17.5402 40.2782 17.1723L36.654 10.8949C36.4417 10.527 36.049 10.3004 35.6242 10.3004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9589 12.9362H31.3945V22.5974",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2108 22.5974L26.4219 17.7668L29.2108 18.8834V12.9362",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3945 17.5991H32.7465",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9609 15.2432V22.5974",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5605 15.1761H36.3603L37.6339 17.4426",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4298 10.4002C47.4288 10.4002 48.2386 9.59041 48.2386 8.59146C48.2386 7.59252 47.4288 6.78271 46.4298 6.78271C45.4309 6.78271 44.6211 7.59252 44.6211 8.59146C44.6211 9.59041 45.4309 10.4002 46.4298 10.4002Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5705 28.7509C18.5694 28.7509 19.3792 27.9411 19.3792 26.9422C19.3792 25.9432 18.5694 25.1334 17.5705 25.1334C16.5715 25.1334 15.7617 25.9432 15.7617 26.9422C15.7617 27.9411 16.5715 28.7509 17.5705 28.7509Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5705 10.4002C18.5694 10.4002 19.3792 9.59041 19.3792 8.59146C19.3792 7.59252 18.5694 6.78271 17.5705 6.78271C16.5715 6.78271 15.7617 7.59252 15.7617 8.59146C15.7617 9.59041 16.5715 10.4002 17.5705 10.4002Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4298 28.7509C47.4288 28.7509 48.2386 27.9411 48.2386 26.9422C48.2386 25.9432 47.4288 25.1334 46.4298 25.1334C45.4309 25.1334 44.6211 25.9432 44.6211 26.9422C44.6211 27.9411 45.4309 28.7509 46.4298 28.7509Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4298 10.4002C47.4288 10.4002 48.2386 9.59041 48.2386 8.59146C48.2386 7.59252 47.4288 6.78271 46.4298 6.78271C45.4309 6.78271 44.6211 7.59252 44.6211 8.59146C44.6211 9.59041 45.4309 10.4002 46.4298 10.4002Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5705 28.7509C18.5694 28.7509 19.3792 27.9411 19.3792 26.9422C19.3792 25.9432 18.5694 25.1334 17.5705 25.1334C16.5715 25.1334 15.7617 25.9432 15.7617 26.9422C15.7617 27.9411 16.5715 28.7509 17.5705 28.7509Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5705 10.4002C18.5694 10.4002 19.3792 9.59041 19.3792 8.59146C19.3792 7.59252 18.5694 6.78271 17.5705 6.78271C16.5715 6.78271 15.7617 7.59252 15.7617 8.59146C15.7617 9.59041 16.5715 10.4002 17.5705 10.4002Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4298 28.7509C47.4288 28.7509 48.2386 27.9411 48.2386 26.9422C48.2386 25.9432 47.4288 25.1334 46.4298 25.1334C45.4309 25.1334 44.6211 25.9432 44.6211 26.9422C44.6211 27.9411 45.4309 28.7509 46.4298 28.7509Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8516 46.4762C11.5074 46.4762 12.0391 45.9445 12.0391 45.2887C12.0391 44.6329 11.5074 44.1012 10.8516 44.1012C10.1957 44.1012 9.66406 44.6329 9.66406 45.2887C9.66406 45.9445 10.1957 46.4762 10.8516 46.4762Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4785 7.05347C12.1344 7.05347 12.666 6.5218 12.666 5.86597C12.666 5.21013 12.1344 4.67847 11.4785 4.67847C10.8227 4.67847 10.291 5.21013 10.291 5.86597C10.291 6.5218 10.8227 7.05347 11.4785 7.05347Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8359 36.7065L53.3984 35.269L51.961 36.7065L53.3984 38.1439L54.8359 36.7065Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0703 58.7272L37.6328 57.2898L36.1954 58.7272L37.6328 60.1647L39.0703 58.7272Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0546 49.9538L16.6172 48.5164L15.1797 49.9538L16.6172 51.3912L18.0546 49.9538Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_53245",
    x1: 6.27132,
    y1: 46.7769,
    x2: 54.7142,
    y2: -1.66595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DDFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6C4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_53245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftTestIcon);
export default __webpack_public_path__ + "static/media/nft-test-icon.3bea2dd441c327ddcf24e0587cf3f590.svg";
export { ForwardRef as ReactComponent };